var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 40,
    viewBox: "0 0 140 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graph #8 \xE2\x80\x94 08/07/2023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Curved Graph",
    d: "M24 32.1758C27.5385 32.1758 27.5385 35.0769 31.0769 35.0769C34.6154 35.0769 34.6154 35.3407 38.1538 35.3407C41.6923 35.3407 41.6923 32.4396 45.2308 32.4396C48.7692 32.4396 48.7692 33.7582 52.3077 33.7582C55.8462 33.7582 55.8462 31.1209 59.3846 31.1209C62.9231 31.1209 62.9231 31.7802 66.4615 31.7802C70 31.7802 70 24 73.5385 24C77.0769 24 77.0769 33.0989 80.6154 33.0989C84.1538 33.0989 84.1538 34.6813 87.6923 34.6813C91.2308 34.6813 91.2308 34.1538 94.7692 34.1538C98.3077 34.1538 98.3077 36 101.846 36C105.385 36 105.385 34.4176 108.923 34.4176C112.462 34.4176 112.462 24.6593 116 24.6593M116 24.6593V24.6593Z",
    stroke: "#17B26A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dots"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 24,
    cy: 32.1758,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 31.0769,
    cy: 35.0769,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 38.1538,
    cy: 35.3406,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 45.2307,
    cy: 32.4395,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    cx: 52.3077,
    cy: 33.7583,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    cx: 59.3846,
    cy: 31.1208,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    cx: 66.4615,
    cy: 31.7803,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    cx: 73.5385,
    cy: 24,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 80.6154,
    cy: 33.0989,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    cx: 87.6923,
    cy: 34.6814,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    cx: 94.7693,
    cy: 34.1538,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    cx: 101.846,
    cy: 36,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    cx: 108.923,
    cy: 34.4175,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    cx: 116,
    cy: 24.6594,
    r: 2,
    fill: "#17B26A",
    stroke: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphUp);
export default __webpack_public_path__ + "static/media/graphUp.f8a610b4d2783c32e6e88f9efc0324ee.svg";
export { ForwardRef as ReactComponent };